<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.col-lg-6.col-xl-4.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            i.fa.fa-search
          DebounceInput(autofocus type="text" v-model="search" :placeholder="$t('message.search_by_id')" @enter="getPromoMemberListFree()" size="sm")
      .form-group.col-12.col-lg-6.col-xl-4
        b-input-group(size="sm")
          b-input-group-text(slot="prepend" :title="$t('ui.all_ongoing')")
            span {{ $t('ui.all_ongoing') }}
          b-input-group-text(slot="append")
            label.custom-switch
              input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="allOngoing" @change="getPromoMemberListFree(true)")
              span.custom-switch-indicator
      .col-12
      .form-group.col-12.col-lg-6.col-xl-3.mb-1(v-if="!allOngoing")
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.status') }}
          b-form-select(v-model="promoStatus" @change="getPromoMemberListFree(true)" size="sm").mr-3
            option(value=-1) {{ $t('ui.all') }}
            option(value=1) {{ $t('ui.on_going') }}
            option(value=0) {{ $t("ui.knock_off") }}
      .form-group.col-12.col-xl-8.mb-1(v-if="!allOngoing")
        DateRangePicker(:value="dateRange" @update="getData")
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getPromoMemberListFree(true)"
          variant="primary"
          size="sm"
        )

  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)"
        )
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="10%" @click="sortOrder('account_id')")
                  span(:title="$t('ui.account')") {{ $t('ui.account') }}
                  .float-right
                    i(:class="changeSortKey('account_id')")
                th.text-center(width="7%" @click="sortOrder('criteria')")
                  span(:title="$t('ui.criteria')") {{ $t('ui.criteria') }}
                  .float-right
                    i(:class="changeSortKey('criteria')")
                th.text-right(width="7%")
                  span(:title="$t('ui.base_amount')") {{ $t('ui.short.base_amount') }}
                th.text-right(width="7%" @click="sortOrder('rollover')")
                  span(:title="$t('ui.rollover')") {{ $t("ui.rollover") }}
                  .float-right
                    i(:class="changeSortKey('rollover')")
                th.text-right(width="10%")
                  span(:title="$t('ui.completed_amount')") {{ $t("ui.short.completed_amount") }}
                  span /
                  span(:title="$t('ui.target_amount')") {{ $t("ui.short.target_amount") }}
                th.text-right(width="9%")
                  span(:title="$t('ui.max_withdraw_amt')") {{ $t("ui.max_withdraw_amt") }}
                th.text-center(width="6%" @click="sortOrder('ongoing')")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                  .float-right
                    i(:class="changeSortKey('ongoing')")
                th.text-center(width="6%")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
                th.text-right(width="8%" @click="sortOrder('claim_date')")
                  span(:title="$t('ui.claim_date')") {{ $t("ui.claim_date") }}
                  .float-right
                    i(:class="changeSortKey('claim_date')")
            tbody.clusterize-content
              tr(v-if="promoMemberList.length == 0")
                td(:colspan="promoStatus != 1 ? '16' : '14'").text-center
                  span {{ $t('message.no_data_available') }}
              template(v-for="(item, index) in promoMemberList")
                tr
                  td.text-center
                    span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                  td
                    span(:title="item.account_id") {{ item.account_id }}
                    .float-right
                      i.fa.fa-lg(:title="$t('ui.detail')" size="sm" @click="onOffDetail2(item, index)" :class="currId2 == item.account_id + '_' + index ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                  td.text-center
                    span(:title="item.criteria") {{ item.criteria }}
                  td.text-right
                    span(:title="$n(item.base_amount, 'currency')") {{ $n(item.base_amount, 'currency') }}
                  td.text-right
                    span(:title="item.rollover") {{ item.rollover }}
                  td.text-right
                    span(v-if="item.criteria.toUpperCase() == 'WIN'" :title="$n(item.accumulate_win, 'currency')") {{ $n(item.accumulate_win, 'currency') }}
                    span(v-if="item.criteria.toUpperCase() == 'TURNOVER'" :title="$n(item.accumulate_turnover, 'currency')") {{ $n(item.accumulate_turnover, 'currency') }}
                    span /
                    span(:title="$n(item.target_amount, 'currency')") {{ $n(item.target_amount, 'currency') }}
                  td.text-right
                    span(:title="$n(item.max_withdraw_amount, 'currency')") {{ $n(item.max_withdraw_amount, 'currency') }}
                  td.text-center
                    span
                      i(:class="{'fas fa-check text-info': item.ongoing, 'fas fa-times text-warning': !item.ongoing  }")
                  td.text-center
                    span.mr-1(v-if="item.ongoing && isEditAccess")
                      a.fas.fa-hand-paper.btn.btn-ssm.btn-danger(href="javascript:void(0)" @click="knockOffFreeCreditMember(item)" :title="$t('ui.knock_off')")
                    span.mr-1(v-if="!item.ongoing")
                      a.fas.fa-info-circle.btn.btn-ssm.btn-info(href="javascript:void(0)" :title="item.knockoff_reason")
                    span(v-if="item.topup_id")
                      a.fa.btn.btn-ssm(href="javascript:void(0)" @click="onOffDetail(item)" :title="$t('ui.log')" :class="currId == item.topup_id ? 'fa-eye-slash btn-danger' : 'fa-eye btn-success'" style="cursor: pointer;")
                  td.text-right
                    span(:title="$moment(item.claim_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.claim_date).format('YYYY-MM-DD, HH:mm:ss') }}
                tr(v-if="isShowDetail2 == true && currId2 == item.account_id + '_' + index")
                  td(:colspan="promoStatus != 1 ? '16' : '14'")
                    table.table.table-sm.table-bordered.table-striped.table-hover
                      thead.thead-dark
                        tr
                          th.text-right(width="10%")
                            span(:title="$t('ui.withhold_amount')") {{ $t("ui.withhold_amt") }}
                          th(width="10%")
                            span(:title="$t('ui.remark')") {{ $t("ui.remark") }}
                          th.text-right(width="15%" v-if="promoStatus != 1")
                            span(:title="$t('ui.knock_off_date')") {{ $t("ui.short.knockoff_by") }} / {{ $t("ui.short.knockoff_date") }}
                          th.text-right(width="10%")
                            span(:title="$t('ui.created_by')") {{ $t("ui.created_by") }}
                      tbody.clusterize-content
                        tr
                          td.text-right
                            span(:title="$n(item.withhold_amount, 'currency')") {{ $n(item.withhold_amount, 'currency') }}
                          td
                            span(:title="item.remark") {{ item.remark }}
                          td.text-right(v-if="promoStatus != 1")
                            span.d-block {{ item.knockoff_by }}
                            span(v-if="item.knockoff_date" :title="$moment(item.knockoff_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.knockoff_date).format('YYYY-MM-DD, HH:mm:ss') }}
                          td.text-right
                            span(:title="item.created_by") {{ item.created_by }}
                    table.table.table-sm.table-bordered.table-striped.table-hover(v-if="item.promotion_id == 'MB'")
                      thead.thead-dark
                        tr
                          th
                            span(:title="$t('ui.provider_list')") {{ $t("ui.provider_list") }}
                      tbody.clusterize-content
                        tr
                          td
                            template(v-if="item.provider_list")
                              b-badge.mr-1.mb-1(
                                v-for="(provider, i) in item.provider_list.split(',').map(p => p.trim())"
                                :key="provider"
                                variant="secondary"
                              )
                                | {{ provider }}
                            template(v-else)
                                b-badge {{ $t('ui.all') }}

                tr(v-if="isShowDetail == true && currId == item.topup_id")
                  td(:colspan="promoStatus != 1 ? '16' : '14'")
                    table.table.table-sm.table-bordered.table-striped.table-hover
                      thead.thead-dark
                        tr
                          th(width="5%")
                            span(:title="$t('ui.topup_id')") {{ $t("ui.topup_id") }}
                          th(width="10%")
                            span(:title="$t('ui.deposit_amount')") {{ $t("ui.deposit_amount") }}
                          th(width="11%")
                            span(:title="$t('ui.bonus_amount')") {{ $t("ui.bonus_amount") }}
                          th(width="12%")
                            span(:title="$t('ui.type')") {{ $t("ui.type") }}
                          th(width="6%")
                            span(:title="$t('ui.before')") {{ $t("ui.before") }}
                          th(width="6%")
                            span(:title="$t('ui.after')") {{ $t("ui.after") }}
                          th(width="10%")
                            span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                      tbody.clusterize-content
                        tr(v-for="(item1, index) in logList")
                          td
                            span.d-block(:title="item1.topup_id") {{ item1.topup_id }}
                            span.small.text-info.d-block(:title="item1.ref_id") {{ item1.ref_id }}
                          td
                            span(:title="$n(item1.deposit_amount, 'currency')") {{ $n(item1.deposit_amount, 'currency') }}
                          td
                            span(:title="$n(item1.bonus_amount, 'currency')") {{ $n(item1.bonus_amount, 'currency') }}
                          td
                            span(:title="item1.action_type") {{ item1.action_type }}
                          td
                            table.table.table-sm
                            tr
                              th.text-center {{ $t("ui.deposit") }}
                              th.text-center {{ $t("ui.base") }}
                              th.text-center {{ $t("ui.bonus") }}
                              th.text-center {{ $t("ui.target") }}
                            tr
                              td.text-center(:title='$t("ui.deposit_amount")') {{ $n(item1.deposit_amount_before, 'currency') }}
                              td.text-center(:title='$t("ui.base_amount")') {{ $n(item1.base_amount_before, 'currency') }}
                              td.text-center(:title='$t("ui.bonus_amount")') {{ $n(item1.bonus_amount_before, 'currency') }}
                              td.text-center(:title='$t("ui.target_amount")') {{ $n(item1.target_amount_before, 'currency') }}
                          td
                            table.table.table-sm
                            tr
                              th.text-center {{ $t("ui.deposit") }}
                              th.text-center {{ $t("ui.base") }}
                              th.text-center {{ $t("ui.bonus") }}
                              th.text-center {{ $t("ui.target") }}
                            tr
                              td.text-center(:title='$t("ui.deposit_amount")') {{ $n(item1.deposit_amount_after, 'currency') }}
                              td.text-center(:title='$t("ui.base_amount")') {{ $n(item1.base_amount_after, 'currency') }}
                              td.text-center(:title='$t("ui.bonus_amount")') {{ $n(item1.bonus_amount_after, 'currency') }}
                              td.text-center(:title='$t("ui.target_amount")') {{ $n(item1.target_amount_after, 'currency') }}
                          td.text-right
                            span(:title="$moment(item1.created_date).format('YYYY-MM-DD HH:mm:ss')") {{ $moment(item1.created_date).format('YYYY-MM-DD HH:mm:ss') }}
    knockofffreecreditmember(ref="knockofffreecreditmember" :item="selectedMember"  @clicked="afterKnockOffFreeCreditMember" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import knockofffreecreditmember from "@/components/promo/knockOffFreeCreditMember.vue";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    knockofffreecreditmember,
    DateRangePicker
  },
  data: () => ({
    loading: false,
    promoMemberList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null,
    },
    promoStatus: -1,
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    selectedMember: null,
    sortKey: "account_id",
    sortType: "asc",
    allOngoing: false,
    currId: null,
    currId2: null,
    isShowDetail: false,
    isShowDetail2: false,
    logList: []
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizePromo;
    },
    getAccountType() {
      return this.$store.getters.accountType;
    },
    getPromoStatus() {
      if (this.promoStatus == 1)
        return true;
      else if (this.promoStatus == 0)
        return false;
      else
        return null;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_promomemberfree");
    }
  },
  mounted: function() {
  },
  methods: {
    refresh() {
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');

      this.getPromoMemberListFree(true);
    },
    onOffDetail(item) {
      this.isShowDetail2 = false;
      this.currId2 = null;
      if (this.isShowDetail == true) {
        if (this.currId == item.topup_id) {
          this.isShowDetail = false;
          this.currId = null;
          this.logList = [];
        } else {
          this.isShowDetail = false;
          this.currId = null;
          this.isShowDetail = true;
          this.currId = item.topup_id;
          this.getPromoMemberLog();
        }
      } else {
        this.isShowDetail = true;
        this.currId = item.topup_id;
        this.getPromoMemberLog();
      }
    },
    onOffDetail2(item, index) {
      this.isShowDetail = false;
      this.currId = null;
      this.logList = [];
      if (this.isShowDetail2 == true) {
        if (this.currId2 == item.account_id + "_" + index) {
          this.isShowDetail2 = false;
          this.currId2 = null;
        } else {
          this.isShowDetail2 = false;
          this.currId2 = null;
          this.isShowDetail2 = true;
          this.currId2 = item.account_id + "_" + index;
        }
      } else {
        this.isShowDetail2 = true;
        this.currId2 = item.account_id + "_" + index;
      }
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getPromoMemberListFree(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getPromoMemberListFree(true);
    },
    knockOffFreeCreditMember: function(e) {
      this.selectedMember = e;
      this.$refs.knockofffreecreditmember.$refs.knockOffFreeCreditMember.show();
    },
    afterKnockOffFreeCreditMember: function() {
      this.getPromoMemberListFree(true);
      this.$helpers.showDialog(this.$t("ui.combine.knock_off_free_credit_member"), this.$t("message.success"), "success");
    },
    getPromoMemberListFree: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.promotionMemberListFreeUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          ongoing: this.getPromoStatus,
          only_ongoing: this.allOngoing,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        if (this.search.trim() != '')
          json.member_id = this.search;

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.promoMemberList = response.data.dt;
                  this.totalRow = this.promoMemberList.length > 0 ? this.promoMemberList[0].totalrows : 0;
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.totalRow = 0;
        this.promoMemberList = [];
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getPromoMemberLog: function() {
      if (this.checkDateRange()) {
        let url = config.promotionMemberLogGetUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          topup_id: this.currId
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.logList = response.data.dt;
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.totalRow = 0;
        this.promoMemberList = [];
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSizePromo", pageSize);
      this.currentPage = 1;
      this.getPromoMemberListFree(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getPromoMemberListFree();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>